import openModal from 'App/services/Modal/Modal';
import RequestBuilder from 'Resources/RequestBuilder';

export default function createActivity(
	rb: RequestBuilder,
	entity: string,
	name?: string | null,
	extraParams?: object,
	numSelected?: number
) {
	openModal('CreateActivityModal', {
		customerId: Tools.AppService.getCustomerId(),
		filters: rb,
		entity,
		name,
		extraParams,
		numSelected
	} as any);
}
